import { UseFormReturn } from 'react-hook-form';
import { MiscellaneousField } from '../../reportsTypes';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  InfoIconTooltip,
  Input,
} from '@ais-ui/ui-core';

interface StringItemProps {
  fieldName: string;
  form: UseFormReturn;
  fieldInfo: MiscellaneousField;
}

export const MiscellaneousStringItem = ({
  fieldName,
  form,
  fieldInfo,
}: StringItemProps) => {
  return (
    <FormField
      key={fieldName}
      control={form.control}
      name={fieldName}
      render={({ field }) => (
        <FormItem>
          <div className="flex justify-between">
            <FormLabel>
              {fieldInfo.name}: {fieldInfo.required && '*'}
            </FormLabel>
            {fieldInfo.help && (
              <InfoIconTooltip className='mr-2'>{fieldInfo.help}</InfoIconTooltip>
            )}
          </div>
          <FormControl onChange={() => form.clearErrors()}>
            <Input type="text" placeholder={fieldInfo.placeholder} maxLength={fieldInfo.maxLength} {...field} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
export type FieldEnabledState = Record<string, boolean>;
